export const STATIC_COMMON_FIELDS = {
    S9: 'listedCurrency',
    S12: 'name',
    S13: 'issuerDesc',
    S31: 'contractName',
    S214: 'listingExchange',
    S650: 'oneWeekBackClose',
    S651: 'oneMonthBackClose',
    S652: 'threeMonthBackClose',
    S653: 'sixMonthBackClose',
    S654: 'oneYearBackClose',
    S658: 'threeMonthAvgVolume',
    S676: 'MICCode',
    S721: 'exchangeName',
    S1012: 'CUSIP',
    S1017: 'shareClassDescription',
    S1018: 'shareClassStatusID',
    S1043: 'MSSector',
    S1077: 'PERatio',
    S1315: 'MSMarketCapAllShareClasses',
    S1361: 'MSSharesOutstanding',
    S1734: 'localLanguageName',
    S1776: 'primaryMICCode',
    S3052: 'MSFundsCategoryId',
    S3053: 'MSFundsGlobalCategoryId',
    S3059: 'MSInvestmentId',
    S3076: 'fundType',
    S3327: 'underlyingStatus', // 1 – active, 2 – delisted
    S3377: 'MSStandardName',
    S3726: 'assetType'
};
